import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../config/NaeSSchema";

class ChallengeModel extends Model {
  static reducer(action, ChallengeModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.Challenge.schema:
        action.payload.forEach((payload) => {
          const dbData = ChallengeModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          ChallengeModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
ChallengeModel.modelName = "ChallengeModel";

ChallengeModel.fields = {
  id: attr(),
};

export default ChallengeModel;